module.exports = __webpack_public_path__ + "media/images/soar/site/icons/icon_1-9b36f6b64ce6ec5f0566e4f5949e50c7.svg";